<div
  [innerHTML]="content"
  [ngClass]="textClasses"
  class="txt-percian-gray w-full text-xs mx-auto"
></div>
